import { mount } from 'svelte';
import App from './App.svelte';

import './styles/spacing-l-plus.css';
import './app.css';

const app = mount(App, {
	target: document.body,
});

export default app;
